import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SocketService } from '@shared/services';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  private socketService = inject(SocketService);

  constructor() {
    window.addEventListener('beforeunload', (event) => {
      this.socketService.disconnectAll();
      const keys = ['theme', 'studio'];
      keys.forEach((key) => {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
      });
    });
  }
}
